<nav class="tc-breadcrumb" aria-label="Breadcrumb" *ngIf="visible">
  <ol class="tc-breadcrumb-list">
    <li class="tc-breadcrumb-item" *ngFor="let crumb of crumbs; let last = last; let first = first">
      <span class="tc-breadcrumb-separator" *ngIf="!first" aria-hidden="true">›</span>

      <a *ngIf="crumb.url && !last; else currentCrumb" class="tc-breadcrumb-link" [routerLink]="crumb.url">{{ crumb.label }}</a>

      <ng-template #currentCrumb>
        <span class="tc-breadcrumb-current" [attr.aria-current]="last ? 'page' : null">{{ crumb.label }}</span>
      </ng-template>
    </li>
  </ol>
</nav>
